const CHARS = 'ABCDEFGHJKMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789'

export function generateCaptcha(length = 4) {
  let code = ''
  for (let i = 0; i < length; i++) {
    code += CHARS[Math.floor(Math.random() * CHARS.length)]
  }
  return code
}

export function verifyCaptcha(input, code) {
  return String(input || '').trim().toLowerCase() === String(code || '').toLowerCase()
}
